interface Props {
  title: React.ReactNode;
  rightContent?: React.ReactNode;
}

export const PageTitle = ({ title, rightContent }: Props) => {
  return (
    <div className="flex items-center justify-between">
      <div className="sm:text-xl text-base font-bold mb-2">{title}</div>
      {rightContent}
    </div>
  );
};
